




import { Component, Vue } from 'vue-property-decorator'
import store from '@/apps/open/store'

@Component
export default class Index extends Vue {
}
